
export class MaintenanceRoutineModel {
  maintenanceRoutineId: number = 0;
  companyId: number = 0;
  articleId: number = 0;
  active: boolean = false;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}